import React, { useEffect, useRef } from 'react';
import Chart from 'chart.js';
import { customTooltips } from '../../../new/Utils/customTooltips';

const RadarChartWheel = ({ bardData,isMobile,isTablet }) => {
  const chartRef = useRef(null);
  const chartInstanceRef = useRef(null);

  useEffect(() => {
    // Define the plugin to draw data values and avoid overlapping
    const dataValuePlugin = {
      id: 'dataValuePlugin',
      afterDatasetsDraw: chart => {
        // Check if the chart being drawn is the intended radar chart
        if (chart.canvas === chartRef.current) {
          const ctx = chart.ctx;
          // Set the text color to black
          ctx.fillStyle = 'black';
          ctx.font = Chart.helpers.fontString(
            Chart.defaults.global.defaultFontSize,
            'normal',
            Chart.defaults.global.defaultFontFamily
          );
          ctx.textAlign = 'center';
          ctx.textBaseline = 'middle';

          chart.data.datasets.forEach((dataset, i) => {
            const meta = chart.getDatasetMeta(i);
            const valuePositions = []; // Store the positions of the drawn values

            meta.data.forEach((element, index) => {
              const dataString = dataset.data[index].toString();
              const valueWidth = ctx.measureText(dataString).width;
              const valueHeight = parseInt(ctx.font, 10) || 12; // Approximate height based on font size
              let yPosition = element._model.y - 10;

              // Check for overlapping with previously drawn values
              let overlapping = false;
              valuePositions.forEach(pos => {
                if (
                  Math.abs(yPosition - pos.y) < valueHeight &&
                  Math.abs(element._model.x - pos.x) < valueWidth
                ) {
                  overlapping = true;
                }
              });

              // Adjust the yPosition if overlapping
              if (overlapping) {
                yPosition = element._model.y + 20;
              }

              // Draw the value at the adjusted position
              ctx.fillText(dataString, element._model.x, yPosition);

              // Store the drawn value position
              valuePositions.push({ x: element._model.x, y: yPosition });
            });
          });
        }
      },
    };

    // Register the plugin if it's not already registered
    // if (Chart.plugins.getAll().filter(p => p.id === 'dataValuePlugin').length === 0) {
    //   Chart.plugins.register(dataValuePlugin);
    // }

    if (chartRef.current) {
      const ctx = chartRef.current.getContext('2d');
      if (chartInstanceRef.current) {
        chartInstanceRef.current.destroy();
      }

      chartInstanceRef.current = new Chart(ctx, {
        type: 'radar',
        data: bardData,
        options: {
          scale: {
            ticks: {
              beginAtZero: true,
              max: 10,
              // stepSize: 1,
              fontStyle: 'bold',
            },
            pointLabels: {
              fontSize: isMobile ? 6 : isTablet ? 8 : 12,
                fontStyle: 'bold',
              },
            angleLines: {
              display: true,
            },
            gridLines: {
              circular: true,
            },
          },
          legend: {
            display: true,
            position: isMobile ? 'bottom' : 'top',
            labels: {
              padding: 20,
              // boxWidth: 15,
              margin: 0,
            },
      
           
          },
         
          tooltips: {
            enabled: false,
            custom: customTooltips,
            callbacks: {
              title: function (tooltipItem, data) {
                const datasetIndex = tooltipItem[0].datasetIndex;
                return data.datasets[datasetIndex].label;
              },
              label: function (tooltipItem, data) {
                const value = tooltipItem.yLabel;
                return `${value}`;
              }
            }
          },
          animation: {
            duration: 0, // Disable animations
          },
          elements: {
            line: {
              tension: 0,
            },
          },
        },
        // plugins: [dataValuePlugin],
      });
    }

    return () => {
      if (chartInstanceRef.current) {
        chartInstanceRef.current.destroy();
      }
    };
  }, [bardData]);

  return (
    <canvas
      width={isMobile ? '400' : isTablet ? '500' : undefined}
      height={isMobile ? '400' : isTablet ? '500' : undefined}
      ref={chartRef}
    />
  );
};

export default RadarChartWheel;


// WEBPACK FOOTER //
// ./src/_components/common/RadarChartWheel/RadarChartWheel.jsx